import { toast } from 'react-toastify';
import i18n from '../i18n';

export const showSuccessToast = (message) => {
  toast.success(message, {
    hideProgressBar: true,
    closeButton: true,
    autoClose: 1000
  });
};

export const showErrorToast = (message) => {
  toast.error(message, {
    hideProgressBar: true,
    closeButton: true,
    autoClose: 1000
  });
};

// Utility function to change language and persist the preference
export const changeLanguage = (language) => {
  try {
    // Change the i18n language
    i18n.changeLanguage(language);

    // Update the user's preferred language in localStorage
    const currentUser = JSON.parse(localStorage.getItem('CurrentUser'));
    if (currentUser) {
      currentUser.preferredLanguage = language;
      localStorage.setItem('CurrentUser', JSON.stringify(currentUser));
    }

    return true;
  } catch (error) {
    console.error('Error changing language:', error);
    return false;
  }
};

export const getUnitTypes = (unitType) => {
  switch (unitType.toLowerCase()) {
    case 'gram':
      return 'ગ્રામ (Gram)';
    case 'kgs':
      return 'કિગ્રા (KGS)';
    case 'liter':
      return 'લિટર (Liter)';
    case 'ml':
      return 'મિલીલીટર (ML)';
    case 'pieces':
      return 'નંગ (Pieces)';
    case 'per_person':
      return 'માણસો દીઠ (Per Person)';
    default:
      return unitType;
  }
}